import { notify } from '@billy/design-system'
import get from 'lodash/get'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { getBill } from '../query-api'

interface UseGetBillOptions {
  refetchOnMount?: boolean
  shouldNotifyOnError?: boolean
}

export const useGetBill = (billId?: string, options?: UseGetBillOptions) => {
  const { t } = useTranslation()
  const shouldNotifyOnError = options?.shouldNotifyOnError ?? true
  const query = useQuery([QueryKeys.Bill, billId], () => getBill({ billId: billId as string }), {
    enabled: !!billId,
    refetchOnMount: options?.refetchOnMount,
  })

  useEffect(() => {
    if (!shouldNotifyOnError || !query.isError) {
      return
    }

    const message = get(query.error, 'message') || t('bill.notification.fetch_bill_error')
    notify({ id: 'bill-error', message, variant: 'error' })
  }, [query.error, query.isError, shouldNotifyOnError, t])
  return query
}
